import React from 'react';
import PropTypes from 'prop-types';

const Option = ({ children }) => (
  <div style={{ marginBottom: '1em' }}>
    {children}
  </div>
);

Option.propTypes = {
  children: PropTypes.node
};

export default Option;



// WEBPACK FOOTER //
// ./webpack/components/Document/Sections/TermsBuilder/Option.js